/* eslint-disable react/style-prop-object */
import React from 'react';
import ReactDOM from 'react-dom/client';
import 'styles/index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ConfigProvider, theme } from 'antd';
// import CrispChat from 'components/crisp';
import { Provider, ErrorBoundary } from '@rollbar/react'; // Provider imports 'rollbar'
import { ROLLBAR_ACCESS_TOKEN } from 'utils/constants';
import { isLocalhost } from 'utils/utils';
import SupportChat from 'components/supportChat';

const rollbarConfig = {
  accessToken: ROLLBAR_ACCESS_TOKEN,
  environment: isLocalhost() ? 'development' : 'production',
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: '#08a87f',
          borderRadius: 10,
          // fontFamily: "'silka', sans-serif",
          boxShadow: 'none',
          colorLink: '#04cb99',
          controlHeight: 40,
          fontSize: 14,
          algorithm: theme.darkAlgorithm,
          colorTextBase: '#dcdcdc',
          colorTextPlaceholder: '#aeaeae',
          components: {
            Button: {
              colorPrimary: '#04cb99',
              algorithm: true, // Enable algorithm
            },
          },
        },
      }}
    >
      <Provider config={rollbarConfig}>
        <ErrorBoundary>
          <App />
        </ErrorBoundary>
      </Provider>

      {/* <CrispChat /> */}
      <SupportChat />
    </ConfigProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
